import { render, staticRenderFns } from "./ONotification.vue?vue&type=template&id=71bdbeb0&scoped=true&"
import script from "./ONotification.vue?vue&type=script&lang=js&"
export * from "./ONotification.vue?vue&type=script&lang=js&"
import style0 from "./ONotification.vue?vue&type=style&index=0&id=71bdbeb0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdbeb0",
  null
  
)

export default component.exports